import { BrowserRouter, Routes, Route } from 'react-router';
import Home from './components/pages/Home';

export default function MainRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}>
          <Route index path="/home" element={<Home />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
